import { render, staticRenderFns } from "./ProvisionModal.vue?vue&type=template&id=98b6687a&scoped=true"
import script from "./ProvisionModal.vue?vue&type=script&lang=js"
export * from "./ProvisionModal.vue?vue&type=script&lang=js"
import style0 from "./ProvisionModal.vue?vue&type=style&index=0&id=98b6687a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b6687a",
  null
  
)

export default component.exports